<template>
    <v-card>
        <v-card-title>
            Resumo das Cobranças
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="headers" :items="items">
                <template #[`item.description`]="{ item }">
                    <a @click="$router.push(item.to)">{{ item.description }}</a>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import Bill from '@/models/Bill'

export default {
    props: {
        bill: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof Bill
            },
        },
    },

    data: () => {
        return {
            headers: [
                {
                    text: 'Descrição',
                    value: 'description',
                },
                {
                    text: 'Período',
                    value: 'period',
                    align: 'center',
                },
                {
                    text: 'Valor',
                    value: 'amount',
                    align: 'center',
                },
            ],
        }
    },

    computed: {
        items() {
            const items = []

            if (this.bill.periods.length)
                this.bill.periods.forEach(period => {
                    items.push({
                        description: `${period.customer_name} (${period.plan_name})`,
                        period: `${period.formattedStartAt} ~ ${period.formattedEndAt}`,
                        amount: period.formattedValue,
                        to: {
                            name: 'customer.show',
                            params: { id: period.customer_id },
                        },
                    })
                })

            if (this.bill.billInstallments.length)
                this.bill.billInstallments.forEach(installment => {
                    const description =
                        installment.installment == 0
                            ? 'Entrada de parcelamento'
                            : `Parcelamento de fatura ${installment.installment}/${installment.billNegotiation.installments}`
                    items.push({
                        description: description,
                        period: installment.billNegotiation.bill.reference,
                        amount: installment.formattedValue,
                        to: {
                            name: 'bill.show',
                            params: { id: installment.billNegotiation.bill_id },
                        },
                    })
                })

            return items
        },
    },
}
</script>

<style></style>
